import { GET_PAYMENT_URL } from '../actions/pagamenti';

const initialState = {
  loading: false,
  loaded: false,
  result: {},
  error: null,
};

// Get operators list
export const paymentURl = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_PAYMENT_URL}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${GET_PAYMENT_URL}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null,
      };
    case `${GET_PAYMENT_URL}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    default:
      return state;
  }
};
